import React, { PureComponent } from 'react';
import { preFix } from '@/constant';
import styles from './index.module.less';

interface IProps {
  propsConfig: any;
}

class Index extends PureComponent<IProps> {
  static config = {
    name: 'poizon-richText',
  }

  render() {
    const { propsConfig } = this.props;
    const { richText } = propsConfig

    return (
      <div className={preFix + Index.name}>
        <div className={styles.textBox}>
          <div dangerouslySetInnerHTML={{ __html: richText }} />
        </div>
      </div>
    );
  }
}

export default Index;
